import { ref, type Ref, type DirectiveBinding } from 'vue'

interface TooltipParentPosition {
  x: number
  y: number
  parentWidth: number
  parentHeight: number
}

const showTooltip = ref(false)
const tooltipContent = ref('')
const tooltipPosition: Ref<TooltipParentPosition> = ref({
  x: 0,
  y: 0,
  parentWidth: 0,
  parentHeight: 0,
})

const onMouseEnter = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (!target || !target.getBoundingClientRect) return

  const boundingBox = target.getBoundingClientRect()
  tooltipPosition.value = {
    x: boundingBox.x + boundingBox.width / 2,
    y: boundingBox.y,
    parentWidth: boundingBox.width,
    parentHeight: boundingBox.height,
  }
  showTooltip.value = true
  tooltipContent.value = target.getAttribute('aria-label') || ''
}

const onMouseLeave = () => {
  showTooltip.value = false
  tooltipContent.value = ''
}

export const vTooltip = {
  mounted: (element: HTMLElement, binding: DirectiveBinding) => {
    if (binding.value) {
      element.setAttribute('aria-label', binding.value)
      element.addEventListener('mouseenter', onMouseEnter)
      element.addEventListener('mouseleave', onMouseLeave)
    }
  },
  updated: (element: HTMLElement, binding: DirectiveBinding) => {
    if (binding.value) {
      element.setAttribute('aria-label', binding.value)
    } else {
      element.removeAttribute('aria-label')
    }
  },
  unmounted: (element: HTMLElement) => {
    element.removeEventListener('mouseenter', onMouseEnter)
    element.removeEventListener('mouseleave', onMouseLeave)
    onMouseLeave()
  },
}

export const initTooltip = () => {
  return { showTooltip, tooltipPosition, tooltipContent }
}
